export default [
  {
    "name": "运维表",
    "freeze": "A1",
    "styles": [
      {
        "align": "center"
      },
      {
        "align": "center",
        "font": {
          "bold": true
        }
      },
      {
        "font": {
          "bold": true
        }
      }
    ],
    "merges": [
      "A1:J2",
      "A4:D4",
      "E4:G4",
      "H4:J4",
      "A5:J5",
      "A3:J3"
    ],
    "rows": {
      "0": {
        "cells": {
          "0": {
            "text": "运维助手工单统计",
            "merge": [
              1,
              9
            ],
            "style": 1
          },
          "2": {
            "style": 1
          },
          "3": {
            "style": 1
          },
          "4": {
            "style": 1
          },
          "5": {
            "style": 1
          },
          "6": {
            "style": 1
          },
          "7": {
            "style": 1
          },
          "8": {
            "style": 1
          },
          "9": {
            "style": 1
          }
        }
      },
      "1": {
        "cells": {
          "0": {
            "style": 1
          },
          "2": {
            "style": 1
          },
          "3": {
            "style": 1
          },
          "4": {
            "style": 1
          },
          "5": {
            "style": 1
          },
          "6": {
            "style": 1
          },
          "7": {
            "style": 1
          },
          "8": {
            "style": 1
          },
          "9": {
            "style": 1
          }
        }
      },
      "2": {
        "cells": {
          "0": {
            "text": "",
            "merge": [
              0,
              9
            ],
            "style": 0
          }
        }
      },
      "3": {
        "cells": {
          "0": {
            "text": "巡检完成：  -    单",
            "merge": [
              0,
              3
            ],
            "style": 1
          },
          "2": {
            "style": 1
          },
          "3": {
            "style": 1
          },
          "4": {
            "text": "维修完成：  0    单",
            "merge": [
              0,
              2
            ],
            "style": 1
          },
          "5": {
            "style": 1
          },
          "6": {
            "style": 1
          },
          "7": {
            "text": "调试完成：  0    单",
            "merge": [
              0,
              2
            ],
            "style": 1
          },
          "8": {
            "style": 1,
            "text": ""
          },
          "9": {
            "style": 1
          },
          "10": {
            "style": 2
          },
          "11": {
            "style": 2
          },
          "12": {
            "style": 2
          },
          "13": {
            "style": 2
          },
          "14": {
            "style": 2
          },
          "15": {
            "style": 2
          },
          "16": {
            "style": 2
          },
          "17": {
            "style": 2
          },
          "18": {
            "style": 2
          },
          "19": {
            "style": 2
          },
          "20": {
            "style": 2
          },
          "21": {
            "style": 2
          },
          "22": {
            "style": 2
          },
          "23": {
            "style": 2
          },
          "24": {
            "style": 2
          },
          "25": {
            "style": 2
          },
          "26": {
            "style": 2
          }
        }
      },
      "4": {
        "cells": {
          "0": {
            "text": "",
            "merge": [
              0,
              9
            ],
            "style": 0
          }
        }
      },
      "5": {
        "cells": {
          "0": {
            "text": "序号",
            "style": 0
          },
          "1": {
            "text": "日期",
            "style": 0
          },
          "2": {
            "text": "项目",
            "style": 0
          },
          "3": {
            "text": "型号",
            "style": 0
          },
          "4": {
            "text": "工单",
            "style": 0
          },
          "5": {
            "text": "故障",
            "style": 0
          },
          "6": {
            "text": "发单人",
            "style": 0
          },
          "7": {
            "text": "接单人",
            "style": 0
          },
          "8": {
            "text": "工单状态",
            "style": 0
          },
          "9": {
            "text": "是否申请配件",
            "style": 0
          },
        }
      },

      "len": 100
    },
    "cols": {
      "2": {
        width: 200,
      },
      "3": {
        width: 200,
      },
      "len": 27
    },
    "validations": [],
    "autofilter": {}
  }
]